module.exports = __webpack_public_path__ + "static/q20_o-2f1548cfa6417d7627d3dbad228997a7.png";